import Vue from 'vue'
import mod_agenda_comercial from './src/modulos/agenda-comercial/vue/index.js'
import mod_auditor from './src/modulos/auditor/vue/index.js'
import mod_consultas_facturacion from './src/modulos/consultas-facturacion/vue/index.js'
import mod_control_emisoras from './src/modulos/control-emisoras/vue/index.js'
import mod_core from './src/modulos/core/vue/index.js'
import mod_descargar_copion from './src/modulos/descargar-copion/vue/index.js'
import mod_descargar_xframe from './src/modulos/descargar-xframe/vue/index.js'
import mod_escaletas from './src/modulos/escaletas/vue/index.js'
import mod_eventos from './src/modulos/eventos/vue/index.js'
import mod_facturacion_cobros from './src/modulos/facturacion-cobros/vue/index.js'
import mod_galerias from './src/modulos/galerias/vue/index.js'
import mod_gestion_anunciantes from './src/modulos/gestion-anunciantes/vue/index.js'
import mod_gestion_clientes from './src/modulos/gestion-clientes/vue/index.js'
import mod_gestion_cuentas_email from './src/modulos/gestion-cuentas-email/vue/index.js'
import mod_gestion_egm from './src/modulos/gestion-egm/vue/index.js'
import mod_gestion_emisoras from './src/modulos/gestion-emisoras/vue/index.js'
import mod_gestion_grupos from './src/modulos/gestion-grupos/vue/index.js'
import mod_gestion_horaria from './src/modulos/gestion-horaria/vue/index.js'
import mod_gestion_jornada from './src/modulos/gestion-jornada/vue/index.js'
import mod_gestion_permisos from './src/modulos/gestion-permisos/vue/index.js'
import mod_gestion_tarifas from './src/modulos/gestion-tarifas/vue/index.js'
import mod_gestion_usuarios from './src/modulos/gestion-usuarios/vue/index.js'
import mod_invitaciones from './src/modulos/invitaciones/vue/index.js'
import mod_libreta_direcciones from './src/modulos/libreta-direcciones/vue/index.js'
import mod_mis_contratos from './src/modulos/mis-contratos/vue/index.js'
import mod_muro from './src/modulos/muro/vue/index.js'
import mod_objetivos_agentes from './src/modulos/objetivos-agentes/vue/index.js'
import mod_organizar_emisoras from './src/modulos/organizar-emisoras/vue/index.js'
import mod_produccion from './src/modulos/produccion/vue/index.js'
import mod_produccion_audiovisual from './src/modulos/produccion-audiovisual/vue/index.js'
import mod_radiacion from './src/modulos/radiacion/vue/index.js'
import mod_redaccion from './src/modulos/redaccion/vue/index.js'
import mod_solicitudes from './src/modulos/solicitudes/vue/index.js'
import mod_subir_cunas from './src/modulos/subir-cunas/vue/index.js'
import mod_subir_xframe from './src/modulos/subir-xframe/vue/index.js'
import mod_webmail from './src/modulos/webmail/vue/index.js'
Vue.use(mod_agenda_comercial)
Vue.use(mod_auditor)
Vue.use(mod_consultas_facturacion)
Vue.use(mod_control_emisoras)
Vue.use(mod_core)
Vue.use(mod_descargar_copion)
Vue.use(mod_descargar_xframe)
Vue.use(mod_escaletas)
Vue.use(mod_eventos)
Vue.use(mod_facturacion_cobros)
Vue.use(mod_galerias)
Vue.use(mod_gestion_anunciantes)
Vue.use(mod_gestion_clientes)
Vue.use(mod_gestion_cuentas_email)
Vue.use(mod_gestion_egm)
Vue.use(mod_gestion_emisoras)
Vue.use(mod_gestion_grupos)
Vue.use(mod_gestion_horaria)
Vue.use(mod_gestion_jornada)
Vue.use(mod_gestion_permisos)
Vue.use(mod_gestion_tarifas)
Vue.use(mod_gestion_usuarios)
Vue.use(mod_invitaciones)
Vue.use(mod_libreta_direcciones)
Vue.use(mod_mis_contratos)
Vue.use(mod_muro)
Vue.use(mod_objetivos_agentes)
Vue.use(mod_organizar_emisoras)
Vue.use(mod_produccion)
Vue.use(mod_produccion_audiovisual)
Vue.use(mod_radiacion)
Vue.use(mod_redaccion)
Vue.use(mod_solicitudes)
Vue.use(mod_subir_cunas)
Vue.use(mod_subir_xframe)
Vue.use(mod_webmail)
Vue.prototype.SIP_VERSION = '1.13.1'


//////////////////
// WEBPACK FOOTER
// ./modulos.js
// module id = 894
// module chunks = 0